import React from 'react';

export default function TestPage() {
  return (
    <div style={{ 
      padding: '40px', 
      fontFamily: 'Arial', 
      background: '#f0f0f0',
      minHeight: '100vh'
    }}>
      <h1>✅ Test Page Loaded Successfully</h1>
      <p>If you see this, React is working and the blocking issue is specific to certain resources.</p>
      <div style={{ 
        background: 'white', 
        padding: '20px', 
        borderRadius: '5px',
        marginTop: '20px'
      }}>
        <h3>Diagnostics:</h3>
        <p>Browser: {navigator.userAgent.split('/')[navigator.userAgent.split('/').length - 1]}</p>
        <p>Current URL: {window.location.href}</p>
        <button onClick={() => fetch('/api/health').then(r => alert(`Backend: ${r.status}`)).catch(e => alert(`Backend Error: ${e.message}`))}>
          Test Backend Connection
        </button>
      </div>
    </div>
  );
}
